/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ClaimFeedbackUpdate = {
    resolutionReason?: string;
    resolutionStatus?: ClaimFeedbackUpdate.resolutionStatus;
    englishHeader?: string;
    frenchHeader?: string;
    englishMessage?: string;
    frenchMessage?: string;
    isActive?: boolean;
};

export namespace ClaimFeedbackUpdate {

    export enum resolutionStatus {
        CONFIRMED = 'CONFIRMED',
        PARTIALLY_CONFIRMED = 'PARTIALLY_CONFIRMED',
        DECLINED = 'DECLINED',
    }


}

